// @flow strict
import { type ComponentType } from "react";
import styled from "styled-components";

const HiddenDivider: ComponentType<{}> = styled.div`
  margin: 5px;
`;

export default HiddenDivider;
